import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Helpers de formulário
import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


import StaffOjtModal from './Elements/StaffOjtModal';

class StaffOjtsActualSearch extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      confirmed: 0,
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchOJT = this.searchOJT.bind(this);
    this.showOjtModal = this.showOjtModal.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.loadData = this.loadData.bind(this);
    this.actionButton = this.actionButton.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  
  searchOJT(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      ojt_ids: this.state.ojt_ids,
      base_ids: this.state.base_ids,
      staff_ids: this.state.staff_ids,
      examiner_ids: this.state.examiner_ids,
      aircraft_model_subtype_ids: this.state.aircraft_model_subtype_ids,
      aircraft_model_ids: this.state.aircraft_model_ids,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      trained_role: this.state.trained_role,
      result: this.state.result,
      level: this.state.level,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controle/ojt/atual/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.main});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controle/ojt/atual', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircraft_models: responseJson.data.aircraft_models,
            aircraft_model_subtypes: responseJson.data.aircraft_model_subtypes,
            manufacturers: responseJson.data.manufacturers,
            bases: responseJson.data.bases,
            ojts: responseJson.data.ojts,
            staffs: responseJson.data.staffs,
            trained_roles: responseJson.data.trained_roles,
            data: responseJson.data.main,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  actionButton (cell, row) {
    var botao = <button onClick={this.showOjtModal.bind(this, row)}  className="btn btn-xs btn-info"><i className="fa fa-fw fa-eye"></i></button>;                
    return botao;
  }

  showOjtModal (value ,event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ojt/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_staff_ojt:responseJson.data.main});
          self.setState({staff_ojt_aircraft_models:responseJson.data.aircraft_models});
          self.setState({staff_ojt_aircraft_model_subtypes:responseJson.data.aircraft_model_subtypes});
          self.setState({staff_ojt_manufacturers:responseJson.data.staff_ojt_manufacturers});
          self.setState({staff_ojt_items:responseJson.data.staff_ojt_items});
          self.setState({examiner:responseJson.data.examiner});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  
  modalPropsOff (event) {
    this.setState({ modal_props: false, add_message: 0});
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <StaffOjtModal handleAlert={this.props.handleAlert} modal_props={this.state.modal_props} staff_ojt_aircraft_models={this.state.staff_ojt_aircraft_models} staff_ojt_aircraft_model_subtypes={this.state.staff_ojt_aircraft_model_subtypes} staff_ojt_manufacturers={this.state.staff_ojt_manufacturers} staff_ojt_items={this.state.staff_ojt_items} data_staff_ojt={this.state.data_staff_ojt}  examiner={this.state.examiner} />
      <h3 className="page-title">OJT - Modelo Atual</h3>
      <hr/>
      <form onSubmit={this.searchOJT}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Colaboradores:</label>
            <Select
              className="form-field-name"
              name="staff_ids"
              value={this.state.staff_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'staff_ids')}
              options={this.state.staffs}
             
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Tarefa:</label>
            <Select
              className="form-field-name"
              name="ojt_ids"
              value={this.state.ojt_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'ojt_ids')}
              options={this.state.ojts}
             
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Data de início:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
          </div>
          <div className="col-md-6 form-group">
            <label>Data de fim:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nível da tarefa:</label>
            <input type="number" className="form-control" name="level" value={this.state.level} onChange={this.handleChange.bind(this, 'level')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Frotas:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_ids"
              value={this.state.aircraft_model_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'aircraft_model_ids')}
              options={this.state.aircraft_models}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Motores:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_subtype_ids"
              value={this.state.aircraft_model_subtype_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'aircraft_model_subtype_ids')}
              options={this.state.aircraft_model_subtypes}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Fabricante:</label>
            <Select
              className="form-field-name"
              name="manufacturer_ids"
              value={this.state.manufacturer_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'manufacturer_ids')}
              options={this.state.manufacturers}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Base:</label>
            <Select
              className="form-field-name"
              name="base_ids"
              value={this.state.base_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_ids')}
              options={this.state.bases}
              
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Avaliador responsável:</label>
            <Select
              className="form-field-name"
              name="examiner_ids"
              value={this.state.examiner_ids}
              searchable={true}
              multi={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'examiner_ids')}
              options={this.state.staffs}
             
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Função treinada:</label>
            <Select
              className="form-field-name"
              name="trained_role"
              value={this.state.trained_role}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'trained_role')}
              options={this.state.trained_roles}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Satisfatório:</label>
            <Select
              className="form-field-name"
              name="result"
              value={this.state.result}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'result')}
              options={[
                {value: 'SIM', label: 'SIM'},
                {value: 'NÃO', label: 'NÃO'},
              ]}
             
            />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Procurar OJT</button>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há OJTS cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="staff_inscription" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='70'>Mat.</TableHeaderColumn>
        
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Colaborador</TableHeaderColumn>

        <TableHeaderColumn dataField="ojt_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Tarefa</TableHeaderColumn>

        <TableHeaderColumn dataField="ojt_level" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Nível da Tarefa</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Data de início</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Data de fim</TableHeaderColumn>

        <TableHeaderColumn dataField="trained_role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Função Treinada</TableHeaderColumn>

        <TableHeaderColumn dataField="aircraft_model_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Frota</TableHeaderColumn>

        <TableHeaderColumn dataField="aircraft_model_subtype_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Motor</TableHeaderColumn>

        <TableHeaderColumn dataField="manufacturer_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Fabricante</TableHeaderColumn>

        <TableHeaderColumn dataField="base_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Base</TableHeaderColumn>

        <TableHeaderColumn dataField="examiner_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Avaliador responsável</TableHeaderColumn>

        <TableHeaderColumn dataField="result" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>Satisfatório</TableHeaderColumn>
        
        <TableHeaderColumn dataField="id" dataFormat={this.actionButton} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffOjtsActualSearch;



// WEBPACK FOOTER //
// ./src/Components/StaffOjts/StaffOjtsActualSearch.js